/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../common/resources/resources.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../common/common/common.ts" />

namespace OfficeGuy.CRM {
    export class ViewPicker {
        static Init(): void {
            $(document.body).on("change.schemaviewdetails_schemapicker", ".schemaviewdetails .schemapicker", function () {
                ViewPicker.GetViewBySchema($(this));
            });
        }
        static InitEditors(Container?: any): void {
            $("input.viewpicker", Container).each(function () {
                var $Hidden = $(this);
                var Instance = Teva.SelectBox.GetInstance($Hidden);
                if (Instance != null)
                    return;

                $Hidden.attr("data-text", $Hidden.val() == "" ? OfficeGuy.Resources.GetString("CRM", "ViewPicker_PlaceHolder") : $Hidden.data("viewname"));

                Teva.SelectBox.Enable($Hidden, {
                    QueryMethod: function (Terms, QueryByID, PageIndex, Callback) {
                        var Data = {
                            more: false,
                            results: []
                        };

                        Common.AjaxRequest({
                            Method: 'GET',
                            URL: "/views/picker/?schemaid=" + $Hidden.data("schemaid"),
                            SuccessMethod: function (Response) {
                                for (var i = 0; i < Response.List.length; i++) {
                                    if (Response.List[i].ID < -1)
                                        continue;
                                    Data.results.push({
                                        id: Response.List[i].ID,
                                        text: Response.List[i].Name
                                    });
                                }

                                Callback(Data);
                            },
                            ShowLoading: false
                        });
                    },
                    PlaceHolderText: OfficeGuy.Resources.GetString("CRM", "ViewPicker_PlaceHolder"),
                    Enabled: $Hidden.data("schemaid") != "0",
                    AllowClear: false
                });
            });
        }

        static GetViewBySchema($Schema) {
            var SchemaID = $Schema.val();
            var $ViewPickerInput = $("input.viewpicker", $Schema.closest('.schemaviewdetails'));
            $ViewPickerInput.data("schemaid", SchemaID);

            var ViewPickerInstance = Teva.SelectBox.GetInstance($ViewPickerInput);
            ViewPickerInstance.ClearCache();
            ViewPickerInstance.ClearValue();
            if (SchemaID == 0)
                ViewPickerInstance.Disable();
            else {
                ViewPickerInstance.Enable();
                ViewPickerInstance.SetValue("0", "כל השדות");
            }
        }

        static ShowViewPicker(SchemaID, OnSelect, Deleted?) {
            OfficeGuy.Modals.Create({
                Title: OfficeGuy.Resources.GetString("CRM", "ViewPicker_ChooseView"),
                Body: function (BodyContainer) {
                    Common.AjaxRequest({
                        Method: 'GET', 
                        URL: "/views/picker/?schemaid=" + SchemaID + "&deleted=true",
                        SuccessMethod: function (Data) {
                            if (Data.List.length == 0) {
                                BodyContainer.append($(document.createElement('div'))
                                    .text(OfficeGuy.Resources.GetString("CRM", "ViewPicker_Empty")));
                                return;
                            }

                            var List;
                            BodyContainer.append(List = $(document.createElement('ul')));

                            for (var i in Data.List) {
                                var Item = Data.List[i];
                                List.append($(document.createElement('li'))
                                    .append($(document.createElement('a'))
                                        .text(Item.Name)
                                        .attr("href", "#")
                                        .data("viewid", Item.ID)
                                        .on("click", function () {
                                            OnSelect($(this).data("viewid"));
                                            return false;
                                        })
                                    ));
                            }
                        }
                    });
                }
            });
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.CRM.ViewPicker.Init();
});
$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.CRM.ViewPicker.InitEditors(Container);
});